const nebulaBrainDailyTradeRoutesRegistry = [];

export default nebulaBrainDailyTradeRoutesRegistry;
